module.exports = "static/assets/165746cd277a144ddefd62ac5d67b696.svg";